import React from "react";
import content from "../utils/content.json";

function Hello() {
  return (
    <section id="hello" className="container section">
      <div className="row">
        <div className="col-md-10">
          <h2 id="hello_header" className="section__title">
            {content.content.hello.title}
          </h2>
          <div className="section__description">
            {content.content.hello.description.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>
          {/* <a href="" className="section_btn site-btn"><img src="assets/img/img_btn_icon.png" alt="" />Download CV</a> */}
        </div>
      </div>
    </section>
  );
}

export default Hello;
